import { Card } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { ShimmerEffect } from "components/shimmer";

export default function EntityIntegrationsLoader() {
  return (
    <Card className="h-max gap-0 border py-1 shadow-sm">
      <div className="space-y-4 p-4 md:p-6">
        <div className="flex items-center justify-between">
          <ShimmerEffect className="size-10 rounded-md" />
          <ShimmerEffect className="size-8 rounded-md" />
        </div>
        <ShimmerEffect className="h-6 w-32" />
        <div className="space-y-2">
          <ShimmerEffect className="h-4 w-full" />
          <ShimmerEffect className="h-4 w-3/4" />
        </div>
      </div>
      <Separator />
      <div className="flex items-center justify-between px-4 py-4 md:px-6">
        <ShimmerEffect className="h-9 w-24 rounded-md" />
      </div>
    </Card>
  );
}
